import { Alert } from "@mui/material";

import { useAuth } from "@/contexts/AuthContext";
import {
  getMaintenanceBannerMessage,
  shouldShowMaintenanceBannerForRole,
  useIsAppUnderMaintenance,
  useIsMaintenanceBannerEnabled,
  useIsMaintenanceBannerRegularUsersOnly,
} from "@/features/Maintenance/flag";

export function MaintenanceBanner() {
  const { user } = useAuth();
  const isUnderMaintenance = useIsAppUnderMaintenance();
  const enabled = useIsMaintenanceBannerEnabled();
  const regularUsersOnly = useIsMaintenanceBannerRegularUsersOnly();
  const role = user?.user?.role;

  if (
    isUnderMaintenance ||
    !enabled ||
    !shouldShowMaintenanceBannerForRole(role, regularUsersOnly)
  ) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      data-testid="maintenance-banner"
      sx={{
        borderRadius: 0,
        justifyContent: "center",
        "& .MuiAlert-message": { flex: "unset", textAlign: "center" },
      }}
    >
      {getMaintenanceBannerMessage()}
    </Alert>
  );
}
